import React from 'react'
import '../css/header.css'

const HeaderComponent = (props) => {
  return (
    <div className='header' style={{ 
      // background:  props.gradient
      // ? "linear-gradient(to right, #E9F7FF, #E6DEFF)"
      // : props.bg || '#f6f3ff' ,
      background: props.bg || '#f6f3ff',
      color : props.color || '#6e4e9f',marginBottom:"20px"}}>
        <div className="headerimage">
        {/* <img src="/images/ygmlogo.png" alt=""/> */}
        <img src={props.logo} alt=""/>
        </div>
        <div className="headtextdiv">
        <h1 className='headtext' style={{color : props.primaryColor || '#6e4e9f'}}>
          {/* {props.heading} */}
          FoodSensitivity<span style={{color:props.secondaryColor}}>Map</span>
          </h1>
        </div>
            
    </div>
  )
}

export default HeaderComponent